// ----------------------------------------------------------------------
export const createComponents = () => {
    return {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: 'white',
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    height: 6,
                    backgroundColor: 'rgba(255,255,255,0.25)',
                },
            },
        },
        MuiSvgIcon: {
            variants: [
                {
                    props: { fontSize: 'xlarge' },
                    style: {
                        fontSize: '+2.5em',
                    },
                },
                {
                    props: { fontSize: 'xxlarge' },
                    style: {
                        fontSize: '+5em',
                    },
                },
                {
                    props: { fontSize: 'xxxlarge' },
                    style: {
                        fontSize: '+10em',
                    },
                },
            ],
        },
    };
};
